    import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Button, Grid, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";



import {
  fetchGenericNames,
} from "../../store/commonThunks/lookups";

import {
  selectGenericNames,
} from "../../store/commonSelectors/lookupsSelectors";

import { useNavigate } from "react-router-dom";
import GenericNameList from "./components/GenericNameList";

const { Title } = Typography;

const GenericName = () => {

  const dispatch = useDispatch();

  const { useBreakpoint } = Grid;

  const screens = useBreakpoint();

  const genericNames =
    useSelector(selectGenericNames);

  const navigate = useNavigate();

  const handleNavigateToBack = () => {
    navigate("/inventory/dashboard");
  };


  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >

        <Button
          type="text"
          icon={
            <ArrowLeftOutlined
              style={{
                fontSize:
                  !screens.md ? "18px" : "22px",
              }}
            />
          }

          onClick={handleNavigateToBack}

          style={{
            marginRight: 12,
            padding: 0,
            height: "auto",
            lineHeight: "1",
            color: "#000",
          }}
        />

        <Title
          level={!screens.md ? 4 : 2}
          style={{
            margin: 0,
          }}
        >
          Generic Name Manage
        </Title>

      </div>

      <GenericNameList
        genericNames={genericNames}
      />
    </>
  );
};

export default GenericName;